<style lang='less' scoped >
.navmenu{position: relative;}
li {list-style-type:none;}
//动画
@keyframes myfirst
{
  0% {height: 510px}
  75% {height: 0px;}
  100% {height: 120px}
}
.thesignup{text-align: right;margin-top: -60px;font-size: 18px;color: #fff;margin-right: 27px;font-weight: 900;cursor: pointer;}
.marquee{color: white;font-size: 15px;width: 800px;margin-left: 36px;}
.had_top{display: flex; justify-content:space-between;align-items:center;height:110px;padding: 10px 0; width: 1200px;margin: auto;padding: 0;justify-content: flex-end}
// .headnev{display: flex; width:100%;position: relative;flex-direction: column;background: url('../../../../static/index/headerBanner.png') no-repeat; background-size: 100% 100%;padding-top: 10px;}
.headnev{display: flex; width:100%;position: relative;flex-direction: column;padding-top: 10px;}

.logo{height: 60px;width: 270px;color:#fff;margin-top:10px; margin-top: 26px;margin-right: 370px;padding-left: 10px;}
.logo h3{border-bottom: 1px solid white;margin: 0;}
.logo h4{margin: 0;}
.login{height:0px;position: relative;}
.login span{padding: 0 15px;color:#fff;cursor: pointer;}
.login span a{color: #fff !important;}
.login .span_bor{border-right: 1px solid #fff;line-height: 15px;}
img{width:50px}
.menu{display: flex; width:100%;background: url('../../../../static/index/menu.png') no-repeat; background-size: 100% 100%;}
.entry{position: absolute;top: 52px;right: 60px;
  p{color: #d1c700;margin: 8px;letter-spacing: 2px;font-size: 22px;font-weight: bolder;cursor:pointer;	font-family:LiSu;
  a{color: #9EDDFA;}}
}
</style>

<template>
  <div class="navmenu" id="start">
    <div class="top_adt" id="top_adt">
      <a href="/PromoinApp" style="width:100%">
        <img :src="img" style="width:100%;height:100%;vertical-align: middle;" alt="">
      </a>
    </div>
    <div class="headnev" :style="{'background': 'url('+ require('../../../../static/index/headerBanner.png') +')', 'background-size': '100% 100%'}">
      <marquee class="marquee" scrollamount='5'>欢迎来到中国—东盟矿业信息服务平台！平台已纳入中国—东盟信息港建设框架，并入列广西“一带一路”百项重点工程！本站原域名www.camining.org更改为camining.net</marquee>
      <div class="had_top">
        <img src="static/index/logo(1).png" style="width: 320px;position:absolute;left: 190px;" />
        <div class="login">
          <span class="span_bor" v-if="username === ''">
            <router-link to="/LoginIndex">
              登录
            </router-link>
          </span>
          <span class="span_bor">
            <router-link to="/KyforumApp">
              网站首页
            </router-link>
          </span>
          <span class="span_bor" @click="onclickEng">English</span>
          <span class="span_bor">
            <router-link to="/Gywm">
              关于我们
            </router-link>
          </span>
          <span class="span_bor">
            <router-link to="/Members">
              {{ msg }}
            </router-link>
          </span>
          <span @click="exit()">
            退出
          </span>
        </div>
         <div class="entry">
          <p @click="onclick">参会参展</p>
          <p @click="onclick">报名入口</p>
        </div>
      </div>
    </div>
    <MenuPanel class="menu" :menulist="menulist"></MenuPanel>
  </div>
</template>

<script>
/**
 * 罗志远 头部导航栏
 */
import MenuPanel from './MenuPanel.vue'
export default {
  inject: ['reload'],
  components: {MenuPanel},
  data()
  {
    return {
      img: '',
      // 小图
      Simg: '',
      // 大图
      Limg: '',
      menulist:
      [
        {grp: '', namee: 'KyforumApp', namec: '网站首页', target: 'menu', sort: '1'},
        {grp: '', namee: 'KyzxIndex', namec: '矿业资讯', target: 'menu', sort: '2'},
        {grp: '', namee: 'Dmgeonomy', namec: '东盟地学', target: 'menu', sort: '3'},
        {grp: '', namee: 'PromoinApp', namec: '矿业论坛', target: 'menu', sort: '4'},
        {grp: '', namee: 'HzxmKYXMList', namec: '合作项目', target: 'menu', sort: '5'},
        {grp: '', namee: 'KyyztModule', namec: '矿业信息地图', target: 'menu', sort: '6'},
        // {grp: '', namee: 'Kyyztoply', namec: '矿业信息地图', target: 'menu', sort: '6'},
        {grp: '', namee: 'ZlkTabsList', namec: '地学资料', target: 'menu', sort: '7'},
        {grp: '', namee: 'LargeScreen', namec: '数字大屏', target: 'menu', sort: '8'},
        {grp: '', namee: 'Thinktank', namec: '专家智库', target: 'menu', sort: '9'},
        {grp: '', namee: 'Exhibition', namec: '线上展会', target: 'menu', sort: '10'},
        {grp: '', namee: 'TradingFloor', namec: '交易大厅', target: 'menu', sort: '11'}
      ],
      msg: '会员中心',
      username: '',
      islog: true
    }
  },
  watch:
  {
    $route: {
      handler(nval, oval)
      {
        document.querySelector('#start') && document.querySelector('#start').scrollIntoView({ block: 'start' })
      },
      immediate: true,
      deep: true
    }
  },
  created()
  {
    this.getusername()
    this.$nextTick(() =>
    {
      this.getImag()
      this.SetPicture()
    })
  },
  methods:
  {
    SetPicture()
    {
      let topadt = document.querySelector('.top_adt')
      let num = 510
      setTimeout(() =>
      {
        let start = setInterval(() =>
        {
          num -= 6
          topadt.style.height = num + 'px'
          if (topadt.offsetHeight === 0)
          {
            this.img = this.Simg
            clearInterval(start)
            let start1 = setInterval(() =>
            {
              num += 2
              topadt.style.height = num + 'px'
              if (topadt.offsetHeight > 98)
              {
                topadt.style.height = null
                topadt.style.height = 98 + 'px'
                clearInterval(start1)
              }
            }, 15)
          }
        }, 10)
      }, 3000)
    },
    getImag()
    {
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 109,
        _exp: 'id>0'
      }
      window.post.getPost(paras).then((ret) =>
      {
        this.Simg = ret[0].sbanner
        this.Limg = ret[0].lbanner
        this.img = this.Limg
      })
    },
    exit()
    {
      this.reload()
      localStorage.removeItem('username')
      this.$router.push({path: '/loginIndex'})
    },
    getusername()
    {
      if (localStorage.getItem('username'))
      {
        this.username = localStorage.getItem('username')
        let paras = {
          cmd: 'query',
          _major: 11,
          _minor: 28,
          _exp: `username = '${localStorage.getItem('username')}'`
        }
        window.post.getPost(paras).then((ret) =>
        {
          if (ret.length === 1)
            this.msg = `欢迎，${ret[0].passport}`
        })
      }
    },
    onclickEng()
    {
      window.open('https://www.camining.cn/en/index.html', '_blank')
    },
    onclick()
    {
      window.open('https://www.camining.cn/nav/index.html', '_blank')
    },
    _isMobile()
    {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/layout/HeadNavApp.vue